import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e006_err
 * @category 승강기에러코드
 */
export class ElevatorErrorCodeModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 제조사
   *
   * **data type** varchar(5)
   */
  manucd: string;

  /**
   * 기종
   *
   * **data type** varchar(40)
   */
  mdcd: string;

  /**
   * 에러코드
   *
   * **data type** varchar(10)
   */
  errcd: string;

  /**
   * 순번
   *
   * **data type** varchar(6)
   */
   seq: string;

  /**
   * 제목
   *
   * **data type** varchar(255)
   */
  title: string;

  /**
   * 사용유무
   *
   * **data type** varchar(1)
   */
  useyn: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.manucd = data.manucd || '';
    this.mdcd = data.mdcd || '';
    this.errcd = data.errcd || '';
    this.seq = data.seq || '';
    this.title = data.title || '';
    this.useyn = data.useyn || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
